import { render, staticRenderFns } from "./batch-hide-activity.vue?vue&type=template&id=2d3cbb24&"
import script from "./batch-hide-activity.vue?vue&type=script&lang=js&"
export * from "./batch-hide-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports